<top-navig [display]="true" [displayLogo]="false" title="Contactez-nous"></top-navig>
<div class="contact-us" [class.p-95]="ourApp">
  <div class="container heading">
    <!-- <h2 class="text-center">Contactez-nous</h2> -->
    <div class="contact-form" [@fade]="true">
      <!-- <div class="row">
        <div class="col-md-12">
          <p class="info">Nous mettons tout en œuvre pour faciliter votre visite sur notre site et nous voulons faire
            de notre mieux pour répondre à vos attentes. Vous pouvez nous écrire directement depuis ce formulaire.
            Votre message a bien été pris en compte. Nous allons y répondre dans les meilleurs délais.</p>
          <form id="main-contact-form" name="contact-form" method="post" action="#">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <input type="text" name="name" [(ngModel)]="contact.name" class="form-control" placeholder="Nom *"
                    (keyUp)="contactErreur.name=false">
                  <span class="required" *ngIf="contactErreur.name">Merci d'incrire votre nom</span>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input type="email" name="email" [(ngModel)]="contact.email" class="form-control" placeholder="E-mail *"
                    (keyUp)="contactErreur.email=false">
                  <span class="required" *ngIf="contactErreur.email">Merci d'incrire un email valide</span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <input type="text" name="subject" [(ngModel)]="contact.subject" class="form-control" placeholder="Sujet *"
                (keyUp)="contactErreur.subject=false">
              <span class="required" *ngIf="contactErreur.subject">Merci d'incrire le sujet de votre message</span>
            </div>
            <div class="form-group">
              <textarea name="message" id="message" [(ngModel)]="contact.message" class="form-control" rows="4"
                placeholder="Message *" (keyUp)="contactErreur.message=false"></textarea>
              <span class="required" *ngIf="contactErreur.message">Merci d'incrire votre message</span>
            </div>
            <div class="form-group">
              <button type="submit" [disabled]="loader" class="btn-submit" (click)="contactUs()">
                <ng-container *ngIf="loader"><i class='glyphicon glyphicon-refresh spinning'></i>&nbsp;&nbsp;</ng-container>
                Envoyer
              </button>
            </div>
          </form>
        </div>
      </div> -->
      <div class="row">
        <div class="col-sm-12">
          <div class="contact-info wow fadeInUp animated">
            <div class="footer_column contact">
              <hr class="half_space">
              <p> <img src="assets/images/restaurant.svg" style="margin-right: 6px;" width="32px" [alt]="pdv?.name">
                {{pdv?.name}}
              </p>
              <p class="address">
                <i class="flaticon-pin"></i>
                <a #maplink href="#" target="_blank"> {{pdv?.address}}</a>
              </p>
              <p class="phone">
                <i class="flaticon-phone-on-circle"></i>
                <a href="tel:{{pdv?.phone}}">{{pdv?.phone}}</a>
              </p>
              <p class="email" *ngIf="pdv?.emailContact">
                <i class="flaticon-arroba"></i>
                <a href="mailto:{{pdv?.emailContact}}">
                  <span>
                    {{pdv?.emailContact}}
                  </span>
                </a>
              </p>
              <p class="phone" *ngIf="pdv?.facebook">
                <i class="flaticon-facebook"></i>
                <a href="{{pdv?.facebook }}" target="_blank">
                  Contactez nous sur facebook
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-xs-12">
          <div class="copyright clearfix">
            <ul class="social_icon">
              <li>
                <a href="https://www.facebook.com/Andiamo-Pizza-Combs-la-Ville-194789884281933" target="_blank" class="facebook">
                  <i class="flaticon-facebook"></i>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/APizza77" target="_blank" class="facebook">
                  <i class="flaticon-twitter-circular-button"></i>
                </a>
              </li>
              <li>
                <a href="https://plus.google.com/106828318235872526910" target="_blank" class="facebook">
                  <i class="flaticon-google-plus-circular-button"></i>
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/channel/UCfVcmBK8PiP9pf35cxrWRBQ" target="_blank" class="facebook">
                  <i class="flaticon-social"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/andiamo77pizza/" target="_blank" class="twitter-circular-button">
                  <i class="flaticon-picture"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div> -->

    </div>
  </div>
</div>